import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';

// Layout components
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import WhatWeDoPage from "./pages/WhatWeDoPage";
import HelpAHorsePage from "./pages/HelpAHorsePage";
import LiverySchemePage from "./pages/LiverySchemePage";
import EducationPage from "./pages/EducationPage";
import GetInvolvedPage from "./pages/GetInvolvedPage";
import NewsPage from "./pages/NewsPage";
import ContactPage from "./pages/ContactPage";
import RehomingApplicationPage from "./pages/RehomingApplicationPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import SafeguardingPage from "./pages/SafeguardingPage";
import TermsPage from "./pages/TermsPage";
import NotFoundPage from "./pages/NotFoundPage";

// Admin Pages
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminBlogManagementPage from "./pages/AdminBlogManagementPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminDonationsPage from "./pages/AdminDonationsPage";
import AdminEnquiriesPage from "./pages/AdminEnquiriesPage";

// Donation Pages
import DonatePage from "./pages/DonatePage";
import DonateSuccessPage from "./pages/DonateSuccessPage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
        <Routes>
          {/* Home */}
          <Route path="/" element={<><Header /><HomePage /><Footer /></>} />
          
          {/* About */}
          <Route path="/about" element={<><Header /><AboutPage /><Footer /></>} />
          
          {/* What We Do */}
          <Route path="/what-we-do" element={<><Header /><WhatWeDoPage /><Footer /></>} />
          <Route path="/what-we-do/:subpage" element={<><Header /><WhatWeDoPage /><Footer /></>} />
          
          {/* Help a Horse */}
          <Route path="/help-a-horse" element={<><Header /><HelpAHorsePage /><Footer /></>} />
          
          {/* Rehoming Application */}
          <Route path="/rehoming-application" element={<><Header /><RehomingApplicationPage /><Footer /></>} />
          
          {/* Livery Scheme */}
          <Route path="/livery-scheme" element={<><Header /><LiverySchemePage /><Footer /></>} />
          <Route path="/livery-scheme/report" element={<><Header /><LiverySchemePage /><Footer /></>} />
          
          {/* Education */}
          <Route path="/education" element={<><Header /><EducationPage /><Footer /></>} />
          
          {/* Get Involved */}
          <Route path="/get-involved" element={<><Header /><GetInvolvedPage /><Footer /></>} />
          <Route path="/get-involved/:subpage" element={<><Header /><GetInvolvedPage /><Footer /></>} />
          
          {/* News */}
          <Route path="/news" element={<><Header /><NewsPage /><Footer /></>} />
          <Route path="/news/:slug" element={<><Header /><NewsPage /><Footer /></>} />
          
          {/* Contact */}
          <Route path="/contact" element={<><Header /><ContactPage /><Footer /></>} />
          
          {/* Donate */}
          <Route path="/donate" element={<><Header /><DonatePage /><Footer /></>} />
          <Route path="/donate/success" element={<><Header /><DonateSuccessPage /><Footer /></>} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/blog" element={<AdminBlogManagementPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/donations" element={<AdminDonationsPage />} />
          <Route path="/admin/enquiries" element={<AdminEnquiriesPage />} />
          <Route path="/admin/intake-enquiries" element={<AdminEnquiriesPage />} />
          <Route path="/admin/contact-messages" element={<AdminEnquiriesPage />} />
          <Route path="/admin/volunteer-applications" element={<AdminEnquiriesPage />} />
          <Route path="/admin/rehoming-applications" element={<AdminEnquiriesPage />} />
          <Route path="/admin/welfare-reports" element={<AdminEnquiriesPage />} />
          
          {/* Legal pages */}
          <Route path="/privacy-policy" element={<><Header /><PrivacyPolicyPage /><Footer /></>} />
          <Route path="/safeguarding" element={<><Header /><SafeguardingPage /><Footer /></>} />
          <Route path="/terms" element={<><Header /><TermsPage /><Footer /></>} />
          
          {/* 404 */}
          <Route path="*" element={<><Header /><NotFoundPage /><Footer /></>} />
        </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
